var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineVideoSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82 19.75c-1.01-.83-1.57-2.16-1.57-3.75V8c0-3.42 1.33-4.75 4.75-4.75h6c2.04 0 4.18.38 4.64 3.23.07.41-.21.79-.62.86a.747.747 0 0 1-.86-.62c-.21-1.3-.76-1.97-3.16-1.97H7c-2.58 0-3.25.67-3.25 3.25v8c0 .65.13 1.86 1.02 2.59.32.26.37.74.1 1.06-.14.18-.36.27-.57.27-.17 0-.34-.06-.48-.17zM8 20.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c2.58 0 3.25-.67 3.25-3.25v-5c0-.41.34-.75.75-.75s.75.34.75.75v5c0 3.42-1.33 4.75-4.75 4.75H8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.21 17.46-2.64-1.85a.743.743 0 0 1-.18-1.04c.24-.34.7-.42 1.04-.18l2.64 1.85c.44.31.76.34.89.27s.29-.34.29-.88V7c0-.41.34-.75.75-.75s.75.34.75.75v8.62c0 1.43-.69 2-1.1 2.21-.19.1-.48.21-.85.21-.43 0-.96-.14-1.59-.58zM1.49 22.72a.754.754 0 0 1 0-1.06l20-20c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-20 20c-.14.15-.34.22-.53.22s-.38-.07-.53-.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineVideoSlash);
export default __webpack_public_path__ + "static/media/vuesax-outline-video-slash.15b2aa16a505b405ba3592e485e84718.svg";
export { ForwardRef as ReactComponent };